import { AugmentedCognitoUser } from 'Types';

export enum SIGN_IN_COMPONENT {
  SIGNIN = 'SIGNIN',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  RESET_PASSWORD = 'RESET_PASSWORD',
  VERIFICATION_CODE = 'VERIFICATION_CODE',
}

export interface AuthReducer {
  authReducer: AuthState;
}

/**
 * Durable auth facts only. Session state (isAuthenticated, loading, the user
 * profile) is derived by AuthService from token storage and must not be
 * duplicated here. See documentation/auth-architecture.md.
 */
export interface AuthState {
  tempSignUpPass: string | undefined; // used only on sign up to sign in after verification
}

export enum authActionTypes {
  CLEAR_DATA = 'CLEAR_DATA',
  SET_TEMP_SIGNUP_PASS = 'SET_TEMP_SIGNUP_PASS',
}

export interface SetTokenPayload {
  token: string | undefined;
}

export interface SetIdTokenPayload {
  idToken: string;
}

export interface LogInPlayload {
  emailOrPhone: string;
  countryAcronym: string;
  password: string;
}

export interface SignUpPayload {
  name: string;
  emailOrPhone: string;
  password: string;
  repeatPassword: string;
  unknown: string;
  countryAcronym: string;
}

export interface ConfirmSignUpPayload {
  phoneNumber: string;
  countryAcronym: string;
  confirmationCode: string;
}

export interface SetUserPayload {
  user: AugmentedCognitoUser | null;
}

export interface SetPendingEmailOrPhonePayload {
  pendingEmailOrPhone: string;
}

export interface SetPendingEmailOrPhoneSuccessfulPayload {
  pendingEmailOrPhoneSuccessful: boolean;
}

export interface SetTempSignUpPass {
  type: typeof authActionTypes.SET_TEMP_SIGNUP_PASS;
  payload: string | undefined;
}

export interface ClearData {
  type: typeof authActionTypes.CLEAR_DATA;
}

export type AuthActions = SetTempSignUpPass | ClearData;
